import Handlebars from "handlebars/runtime";

(function(exports) {

  Handlebars.registerHelper('pluralize', function(number, single, plural) {
    return (number === 1) ? single : plural;
  });

  function inherits(ctor, baseCtor) {
    ctor.super_ = baseCtor;
    ctor.prototype = Object.create(baseCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    ctor.prototype.super = function() {
      baseCtor.apply(this, arguments);
    };
  }

  exports.Clipboards = {};
  exports.Clipboards.config = {};
  exports.Clipboards.inherits = inherits;
})(window.slideshare_object);
